import {KlassDropdown} from "components"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import UserSelectV3 from "components/UserSelectV3"
import {useModel} from "hooks"
import {useMemo} from "react"
import {Auth} from "types/auth"
import {AppliedFilter, FieldType, FilterKey} from "types/filter"
import {CallLogStatusOptions} from "types/student-call-log"
import {FilterField, KlassappFilters} from "uiKit"

type Props = {
    filterKey?: FilterKey
    onApplyFilter: (payload: AppliedFilter) => void
    initialFilter?: AppliedFilter
    onClearFilter: () => void
}

export function StudentCallLogFilter(props: Props) {
    const model = useModel()
    const {filterKey, initialFilter, onApplyFilter, onClearFilter} = props

    const availableFilters = useMemo(() => {
        let filters: FilterField[] = [
            {
                field: "students",
                label: "Students",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return (
                        <UserSelectV3
                            type={[Auth.UserProfileType.Student]}
                            belongsToMyCampuses={false}
                            isMulti
                            placeholder="Students"
                            {...props}
                        />
                    )
                }
            },
            {
                field: "status",
                label: "Call Status",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <KlassDropdown options={CallLogStatusOptions} isMulti placeholder="Call Status" {...props} />
                }
            },
            {
                field: "program",
                label: "Program",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <ProgramSelect isMulti placeholder="Program" {...props} />
                }
            },
            {
                field: "campus",
                label: "Campus",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <CampusSelect isMulti placeholder="Campus" {...props} />
                }
            }
        ]

        return filters
    }, [])

    return (
        <KlassappFilters
            filterKey={filterKey}
            availableFilters={availableFilters}
            initialFilter={initialFilter}
            onApply={onApplyFilter}
            onClear={onClearFilter}
        />
    )
}
